export const setKustomerWindowProperty = (namespaceStr, value) => {
  if (!window.Kustomer) {
    window.Kustomer = {};
  }
  const namespaces = namespaceStr.split('.');
  const length = namespaces.length;
  let i = 0;
  let currentObj = window.Kustomer;
  while (i < length) {
    const namespace = namespaces[i];
    if (i === length - 1) {
      currentObj[namespace] = value;
    }
    if (currentObj[namespace] === undefined) {
      currentObj[namespace] = {};
    }
    currentObj = currentObj[namespace];
    i += 1;
  }
};
